"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageButtonControl = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@nextui-org/react");
function ImageButtonControl(props) {
    var onClick = props.onClick, _a = props.image, image = _a === void 0 ? null : _a, _b = props.shape, shape = _b === void 0 ? "square" : _b, _c = props.isIconOnly, isIconOnly = _c === void 0 ? true : _c, toolTipContent = props.toolTipContent, hasTooltip = props.hasTooltip, size = props.size, className = props.className, tooltipPosition = props.tooltipPosition;
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "relative cursor-pointer" }, { children: hasTooltip ? ((0, jsx_runtime_1.jsx)(react_1.Tooltip, __assign({ content: toolTipContent, placement: tooltipPosition, className: "text-black" }, { children: (0, jsx_runtime_1.jsx)(react_1.Button, __assign({ size: size, className: className, isIconOnly: isIconOnly, style: { borderRadius: shape == "square" ? "10px" : "1000px" }, onClick: function (e) {
                    e.stopPropagation();
                    if (onClick) {
                        onClick(e.currentTarget);
                    }
                } }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "flex justify-center items-center" }, { children: (0, jsx_runtime_1.jsx)("img", { src: image, className: "flex p-2 w-10 h-10" }) })) })) }))) : ((0, jsx_runtime_1.jsx)(react_1.Button, __assign({ size: size, className: className, isIconOnly: isIconOnly, style: { borderRadius: shape == "square" ? "10px" : "1000px" }, onClick: function (e) {
                e.stopPropagation();
                if (onClick) {
                    onClick(e.currentTarget);
                }
            } }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "flex justify-center items-center" }, { children: (0, jsx_runtime_1.jsx)("img", { src: image, className: "flex p-2 w-10 h-10" }) })) }))) })));
}
exports.ImageButtonControl = ImageButtonControl;
